export default "__VITE_ASSET__D1wqxXIJ__"